var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "400" },
      on: { "click:outside": _vm.cancelAddTemplate },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function(ref) {
            var on = ref.on
            var attrs = ref.attrs
            return [
              _c(
                "v-btn",
                _vm._g(
                  _vm._b(
                    {
                      staticClass: "btn",
                      attrs: { disabled: _vm.addBtnDisabled, text: "" }
                    },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._v(_vm._s(_vm.$t("New")))]
              )
            ]
          }
        }
      ]),
      model: {
        value: _vm.addTemplateVisible,
        callback: function($$v) {
          _vm.addTemplateVisible = $$v
        },
        expression: "addTemplateVisible"
      }
    },
    [
      _c(
        "v-card",
        { key: _vm.addTemplateVisible, staticClass: "popup add_store_popup" },
        [
          _c("h3", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-template" }),
            _vm._v(_vm._s(_vm.$t("New Template Type")) + " ")
          ]),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pt-0" },
                [
                  _c("v-text-field", {
                    staticClass: "form-input",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: _vm.$t("Type Name") + " *",
                      placeholder: "" + _vm.$t("Input the type name"),
                      clearable: ""
                    },
                    on: {
                      keypress: _vm.handleKeyUp,
                      keydown: _vm.clearTabindex
                    },
                    model: {
                      value: _vm.template.typeName,
                      callback: function($$v) {
                        _vm.$set(_vm.template, "typeName", $$v)
                      },
                      expression: "template.typeName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pt-0" },
                [
                  _c("v-select", {
                    staticClass: "form-select",
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      items: _vm.tagTypes,
                      label: "" + _vm.$t("Template Size"),
                      placeholder: "" + _vm.$t("Input the template Size"),
                      clearable: ""
                    },
                    on: { keydown: _vm.clearTabindex },
                    model: {
                      value: _vm.tagType,
                      callback: function($$v) {
                        _vm.tagType = $$v
                      },
                      expression: "tagType"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "d-flex justify-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.addTemplate }
                },
                [_vm._v(_vm._s(_vm.$t("Save")))]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { text: "", icon: "" },
                  on: { click: _vm.cancelAddTemplate }
                },
                [_vm._v(_vm._s(_vm.$t("Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }